import { render, staticRenderFns } from "./ConversationBasicFilter.vue?vue&type=template&id=32102b22&scoped=true&"
import script from "./ConversationBasicFilter.vue?vue&type=script&lang=js&"
export * from "./ConversationBasicFilter.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBasicFilter.vue?vue&type=style&index=0&id=32102b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32102b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32102b22')) {
      api.createRecord('32102b22', component.options)
    } else {
      api.reload('32102b22', component.options)
    }
    module.hot.accept("./ConversationBasicFilter.vue?vue&type=template&id=32102b22&scoped=true&", function () {
      api.rerender('32102b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/ConversationBasicFilter.vue"
export default component.exports